import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Container, makeStyles } from '@material-ui/core';

import { t } from 'src/shared/literals';
import Page from 'src/shared/ui/components/Page';
import Datatable from 'src/shared/ui/components/Datatable';

import getActivityList from 'src/activity/use-cases/getActivityList';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const ActivityListView = () => {
  const classes = useStyles();

  const companyHeadquarterId = localStorage.selectedUserHeadquarter;

  const [list, setList] = useState({
    rows: [],
    count: 0
  });
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [orderBy, setOrderBy] = useState({
    columnName: null,
    orderBy: null
  });

  async function fetchList() {
    const response = await getActivityList({
      companyHeadquarterId,
      search,
      orderBy: orderBy.columnName
        ? `${orderBy.columnName} ${orderBy.orderBy}`
        : '',
      page,
      limit
    });

    setList(response);
  }

  useEffect(() => {
    fetchList();
  }, [page, limit, search, orderBy]);

  const handleSearch = (searchValue) => {
    setPage(0);
    setSearch(searchValue.target.value);
  };

  const handleChangePage = (pageIndex) => {
    setPage(pageIndex);
  };

  const handleChangeLimit = (limitIndex) => {
    setLimit(limitIndex);
  };

  const handleOrderBy = (column) => {
    setOrderBy(column);
  };

  const columnNameList = ['createdAt', 'action', 'description', 'userFullName'];

  return (
    <Page className={classes.root} title="Actividad">
      <Container maxWidth={false}>
        <Datatable
          domainName="ACTIVITY"
          title="Actividad"
          dataList={list.rows}
          count={list.count}
          onSearch={handleSearch}
          onChangePageValue={handleChangePage}
          onChangePageLimit={handleChangeLimit}
          handleOrderBy={handleOrderBy}
          columnNameList={columnNameList}
        />
      </Container>
    </Page>
  );
};

export default ActivityListView;
